<mat-card #upperBar class="upperbar" style="padding: 0px; box-shadow: none;">
  <mat-grid-list cols="7" rowHeight="46px">
    <mat-grid-tile colspan="2">
      <div class="left-tile">
          <div class="logo" style="position: absolute; top: 10px; left: 10px;">
            <div class="square1"></div>
            <div class="square2"></div>
            <img class="pic" src="../../assets/Images/SysSym.png">
          </div>
          <div class="title-col">
            <div class="letter ">{{title}}</div>
            <mat-icon (click)="onIconClick()" class="icon">{{ isSplitScreen ? 'fullscreen' : 'fullscreen_exit' }}</mat-icon>
          </div>
        </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="3">
      <div fxLayout="row" fxLayoutAlign="start center" [ngClass]="isPlayback ? 'playbackMode' : 'contentContainer'">
        <!-- <div fxLayout="row" fxLayoutAlign="start center" class="contentContainer"> -->
        <span class="monospace-font">{{currentDate}}</span>
        <span style="user-select: none;">&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="monospace-font">{{dayName}}</span>
        <span style="user-select: none;">&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span class="monospace-font">{{currentTime}}</span>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="2">
      <div style="position: absolute; right: 4px; margin-right: 5px;" fxLayout="row" fxLayoutAlign="end center">
        <!-- <span><button mat-icon-button (click)="onAlertPolygonClick()" [matTooltip]="'MENUBAR.NAT_NAI' | translate"><div class="svg-image-nainat" [style.background-color]="'white'"
          [style.-webkit-mask-image]="color"></div></button></span> -->
        <span class="buttonContainer"
          style="padding-left: 5px; border-top-left-radius: 30px; border-bottom-left-radius: 30px;"
          *ngIf="userPrem()"><button mat-icon-button (click)="ChannelsClick()" [matTooltip]="'Video Channels'">
            <mat-icon>list_alt</mat-icon>
          </button>&nbsp;
        </span>
        <span class="buttonContainer" *ngIf="userPrem()"><button mat-icon-button (click)="onShowAnalysisClick()"
            [matTooltip]="'Videos in Analysis'">
            <mat-icon>youtube_searched_for</mat-icon>
          </button>&nbsp;
        </span>
        <span class="buttonContainer" *ngIf="userPrem()"><button mat-icon-button (click)="onShowErrorsClick()"
            [style.color]="errorsColor" [matTooltip]="'MENUBAR.ERRORS_LIST' | translate">
            <mat-icon>error</mat-icon>
          </button>&nbsp;
        </span>
        <!-- <span><button mat-icon-button><mat-icon>tune</mat-icon></button></span> -->
        <span class="buttonContainer" *ngIf="userPrem()"><button mat-icon-button (click)="onSearchClick()"
            [disabled]="searchDialogExists()" [matTooltip]="'MENUBAR.ENTITIES_SEARCH' | translate">
            <mat-icon>search</mat-icon>
          </button>&nbsp;
        </span>
        <span class="buttonContainer"><button mat-icon-button [matMenuTriggerFor]="userMenu"
            [matTooltip]="userToolTip()">
            <mat-icon>account_circle</mat-icon>
          </button>&nbsp;
        </span>
        <span class="buttonContainer"><button mat-icon-button [style.color]="commsColor" [matTooltip]="serverHostname()"
            (click)="onConnectClick()" (contextmenu)="onConnect($event)">
            <mat-icon>router</mat-icon>
          </button>&nbsp;
        </span>
        <span class="buttonContainer"
          style="padding-right: 5px; border-top-right-radius: 30px; border-bottom-right-radius: 30px;"><button
            mat-icon-button (click)="onNavToggle()">
            <mat-icon>menu</mat-icon>
          </button>
        </span>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</mat-card>

<!-- <mat-menu #toolsMenu="matMenu">
  <button mat-menu-item *ngFor="let menuTitle of toolsMenuTitles" [disabled]="menuItemDisabled(menuTitle)"
    (click)="onMenuClick(menuTitle, $event)">{{menuTitle}}</button>
</mat-menu>

<mat-menu #windowsMenu="matMenu">
    <button mat-menu-item *ngFor="let menuTitle of windowsMenuTitles" [disabled]="menuItemDisabled(menuTitle)"
      (click)="onMenuClick(menuTitle, $event)">{{menuTitle}}</button>
  </mat-menu>
  
<mat-menu #viewMenu="matMenu">
  <button mat-menu-item *ngFor="let menuTitle of viewMenuTitles" [disabled]="menuItemDisabled(menuTitle)"
    (click)="onMenuClick(menuTitle, $event)">{{menuTitle}}</button>
</mat-menu> -->

<mat-menu #userMenu="matMenu">
  <button disabled="true" class="text" mat-menu-item>{{permTitle()}}</button>
  <button mat-menu-item *ngFor="let menuTitle of userMenuTitles"
    (click)="onMenuClick(menuTitle, $event)">{{menuTitle}}</button>
</mat-menu>